namespace TabAurous.Production {
    export namespace WIPMovementSelectForSplittingService {
        export const baseUrl = 'Production/WIPMovementSelectForSplitting';

        export declare function List(request: CommonMFGRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPMovementSelectForSplitting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPMovementSelectForSplittingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
